import React from "react";
import Overlay from "../Overlay";
import { sweetalert } from "../../App";
import FAQAPI from "../../network/FAQAPI";
import { FAQ } from "../../types/FAQ";

interface FAQViewState {
  showLoading: boolean;
  faqs: FAQ[];
  expandedID: number | null;
}

export class FAQView extends React.Component<any, FAQViewState> {

  constructor(props) {
    super(props);
    this.state = {
      showLoading: false,
      faqs: [],
      expandedID: null,
    };
  }

  componentDidMount() {
    document.title = 'FAQs';
    this.loadFAQs();
  }

  loadFAQs() {
    this.setState({ showLoading: true }, async () => {
      try {
        let response = await FAQAPI.getActiveFAQs();
        if (!response.success) {
          this.setState({ showLoading: false, faqs: [] });
          return sweetalert.fire({ icon: "error", title: "", text: "Unable to load FAQs at this time." });
        }
        this.setState({ faqs: response.data || [], showLoading: false });
      } catch (e) {
        console.error(e);
        this.setState({ showLoading: false });
        return sweetalert.fire({ icon: "error", title: "", text: "Unable to load FAQs at this time." });
      }
    });
  }

  toggle(id: number) {
    this.setState({ expandedID: this.state.expandedID === id ? null : id });
  }

  // Group FAQs by Category, preserving the order returned by the API (DisplayOrder, ID)
  groupByCategory(): { category: string, items: FAQ[] }[] {
    const groups: { category: string, items: FAQ[] }[] = [];
    this.state.faqs.forEach((faq) => {
      const category = faq.CategoryName && faq.CategoryName.trim() !== "" ? faq.CategoryName : "General";
      let group = groups.find(g => g.category === category);
      if (!group) {
        group = { category, items: [] };
        groups.push(group);
      }
      group.items.push(faq);
    });
    return groups;
  }

  render() {
    const groups = this.groupByCategory();
    return (
      <React.Fragment>
        <Overlay show_loading={this.state.showLoading} />
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-12 col-md-12 col-lg-10 col-xl-8 pt-2">
              <main id="main-content" tabIndex={-1} aria-label="Frequently Asked Questions">
                <div className="card mb-2">
                  <div className="card-header verlag-bold">
                    <h3>Frequently Asked Questions</h3>
                  </div>
                  <div className="card-body">
                    {(!this.state.showLoading && this.state.faqs.length === 0) &&
                      <p className="text-center m-0">No FAQs are available at this time.</p>
                    }
                    {groups.map((group) => (
                      <div className="mb-4" key={group.category}>
                        <h4 className="verlag-bold mb-2">{group.category}</h4>
                        {group.items.map((faq) => {
                          const isOpen = this.state.expandedID === faq.ID;
                          return (
                            <div className="card mb-2" key={faq.ID}>
                              <div className="card-header p-0">
                                <button
                                  className="btn btn-link text-left w-100 d-flex justify-content-between align-items-center p-3"
                                  style={{ textDecoration: 'none', color: '#141c54', fontWeight: 'bold' }}
                                  id={`faq-header-${faq.ID}`}
                                  aria-expanded={isOpen}
                                  aria-controls={`faq-panel-${faq.ID}`}
                                  onClick={() => this.toggle(faq.ID)}
                                >
                                  <span>{faq.Question}</span>
                                  <i className={`fa ${isOpen ? 'fa-caret-up' : 'fa-caret-down'} ml-2`} />
                                </button>
                              </div>
                              {isOpen &&
                                <div className="card-body" id={`faq-panel-${faq.ID}`} role="region" aria-labelledby={`faq-header-${faq.ID}`}>
                                  <p className="m-0" style={{ whiteSpace: 'pre-wrap' }}>{faq.Answer}</p>
                                </div>
                              }
                            </div>
                          );
                        })}
                      </div>
                    ))}
                  </div>
                </div>
              </main>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
